import { Card, Row } from '@app/components'
import { maxComputer, maxSmall } from '@app/styles'
import { CardProps, RowProps } from '@app/types'
import styled from 'styled-components'

export const StyledRow = styled((props: RowProps) => <Row {...props} />)`
  background: ${(props) => props.theme.color.baseBgColor};
  padding: 30px;
  width: 100%;
  @media only screen and (max-width: ${maxComputer}) {
    padding: 30px 0px;
  }

  @media only screen and (max-width: ${maxSmall}) {
    padding: 10px;
  }
`

export const StyledCard = styled((props: CardProps) => <Card {...props} />)`
  margin-bottom: 30px;
  .ant-card-body {
    padding: 35px 24px;
  }
`

export const CardRow = styled((props: RowProps) => <Row {...props} />)`
  justify-content: space-between;
  margin-bottom: 10px;
`
